import React, { useState } from 'react'
import { StyledQuickSignupPanel } from './styled'

export const QuickSignupPanel: React.FC = () => {
  const [socialSignupModalIsOpen, setSocialSignupModalIsOpen] = useState(false)
  const toggleSocialSignupModal = () => {
    setTimeout(() => setSocialSignupModalIsOpen(!socialSignupModalIsOpen), 10) // 開いている状態でのリンククリック時に閉じて開くのを防ぐために待機する
  }
  const handleLoginClick = () => {
    location.href = '/login'
  }
  return (
    <StyledQuickSignupPanel
      socialSignupModalIsOpen={socialSignupModalIsOpen}
      toggleSocialSignupModal={toggleSocialSignupModal}
      onLoginButtonClick={handleLoginClick}
    />
  )
}
